import { useEffect, useState } from "react";
import { useHttpRequest } from "../../hooks/useHttpRequest";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import DMSMedia from "./DMSMedia";
import { setOnCall } from "../../app/userState/userStateSlice";

const MainPlugin = () => {
    const { vCallIncomingMessage, vCallState } = useAppSelector((state) => state.vcall);
    const { user } = useAppSelector((state) => state.auth);
    const [meetingStatus, setMeetingStatus] = useState("");
    const [customerName, setCustomerName] = useState("");
    const [alreadyPickedUp, setAlreadyPickedUp] = useState(false)
    const { sendRequest } = useHttpRequest();
    const dispatch = useAppDispatch()
    const createRoom = async () => {

        if (user && vCallIncomingMessage.username !== "" && vCallIncomingMessage.username) {

            dispatch(setOnCall("Receive RTC Call"))
            const baseUrl = String(process.env.REACT_APP_CHAT_SERVICE);
            const payload = {
                deviceId: user.deviceId,
                userName: vCallIncomingMessage.username,
                email: "",
                phoneNumber: "",
                fullName: vCallIncomingMessage.username,
                serviceGroupId: "1",
                tag: "generic",
                agentUserName: user.username,
                agentDeviceId: user.deviceId,
                sessionId: vCallIncomingMessage.sessionid,
                tenantId: user.tenantId,
                channel: "WHATSAPP",
                channelApplicationId: vCallIncomingMessage.channelapplicationid
            }
            await sendRequest({
                baseUrl: baseUrl,
                url: `JoinRoomAll`,
                method: "post",
                body: payload,

            });
        }

    }

    useEffect(() => {
        console.log("Incoming. ", vCallIncomingMessage, meetingStatus)
        if (vCallIncomingMessage.requesttype === "ReceiveCall") {
            setCustomerName(vCallIncomingMessage.username)

        }
        if (user && vCallIncomingMessage && vCallIncomingMessage.roomId !== undefined) {
            if (vCallIncomingMessage.requesttype !== "LeaveRoomNotification" || (vCallIncomingMessage.requesttype === "LeaveRoomNotification" && vCallState.callConnected)) {

                if (!alreadyPickedUp && (meetingStatus === "" || meetingStatus.includes("waiting") || meetingStatus.includes("missing") || meetingStatus === "close")) {
                    console.log("setting up waiting again")
                    setMeetingStatus(`waiting-${vCallIncomingMessage.channel}-dms`)
                    createRoom().catch((err) => { console.log(err) })


                }
                else {
                    setAlreadyPickedUp(true)
                    setMeetingStatus(`meeting-${vCallIncomingMessage.channel}-dms`)
                }
            }

        }
    }, [vCallIncomingMessage])
    return (
        <>
            {(meetingStatus.includes("waiting") || meetingStatus.includes("missing") || meetingStatus.includes("meeting")) &&
                <DMSMedia meetingStatus={meetingStatus} customerName={customerName} roomName={`${vCallIncomingMessage.roomId}`} setMeetingStatus={(status) => {
                    setMeetingStatus(status)
                    if (status === "close")
                        setAlreadyPickedUp(false)
                }}></DMSMedia>
            }
        </>
    );
}

export default MainPlugin;
